// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0ad41cb","455":"a16816a8","977":"93a1627a"}[chunkId] + ".chunk.js";
};